import React from 'react';
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';

  
function Calculator() {


  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  
    return (
      <div className="App">
        <header className="App-header">


          <strong>
            Calculator Simulator
            
          </strong>
          <br />

          {' '}
          We often put large demands on our calculators, without trying to understand what it must be like from their perspective. Calculators are consistently expected to give accurate answers in split-seconds, without knowing if they themselves are correct.
          <br />
          <br />

          The calculator simulator works by connecting you with another user requesting calculations, so you had better not mess it up for them!
          <br />
          <br />
  <form className = "form">
  <label>
    {getRndInteger(-100000000,100000000)} + {getRndInteger(-100000000,100000000)} = ?:
    <input type="text" name="name" />
  </label>
  <input type="submit" value="Submit" />
</form>
  </header>
  </div>

    );
}
  
export default Calculator;
  